/**
 * Block 12 calculator — длина кромки в метрах.
 *
 * **Универсальная формула** (применима ко всем 7 anketa с corpusQ):
 * ```
 * edgeBand = corpusQ × 15
 * ```
 *
 * 15 метров кромки на 1 лист ЛДСП — константа из всех xlsx-листов
 * (`Кухня!C33`, `Шкаф!C32`, `Тумба-ванна!C29`, `Антресоль!C29`,
 *  `Шкаф-санузел!C29`, `ТВ-зона!C31`, `Балкон!C12`).
 *
 * Результат не округляется — `corpusQ` уже целый (`Math.ceil(...)`), значит
 * `corpusQ × 15` тоже целое. Возвращаем число метров (units = pm).
 *
 * Reference: `docs/methodology/calculator-formulas.md` §1.3 + §4.4.
 *
 * @example
 *   edgeBand(5)  // 75   (Кухня L=5000 → corpusQ=5 → edge=75 м)
 *   edgeBand(4)  // 60   (Шкаф L=2000 → corpusQ=4 → edge=60 м)
 *   edgeBand(1)  // 15
 *   edgeBand(0)  // 0    (degenerate, но допускается)
 *
 * @throws Error если `corpusQ` не неотрицательное целое (или non-finite).
 */
export function edgeBand(corpusQ: number): number {
  if (!Number.isFinite(corpusQ)) {
    throw new Error(`edgeBand: expected finite number, got ${corpusQ}`);
  }
  if (corpusQ < 0) {
    throw new Error(`edgeBand: expected non-negative corpusQ, got ${corpusQ}`);
  }
  if (!Number.isInteger(corpusQ)) {
    throw new Error(`edgeBand: expected integer corpusQ, got ${corpusQ}`);
  }
  return corpusQ * 15;
}
